import { render } from "./FieldCreateOverlay.vue?vue&type=template&id=08e636b0&scoped=true&ts=true"
import script from "./FieldCreateOverlay.vue?vue&type=script&lang=ts"
export * from "./FieldCreateOverlay.vue?vue&type=script&lang=ts"

import "./FieldCreateOverlay.vue?vue&type=style&index=0&id=08e636b0&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e636b0"]])

export default __exports__